/**
 * Library version is updated automatically during the
 * release process, do not update this manually.
 */
export const LIBRARY_NAME = '@squareup/cdp';
export const LIBRARY_VERSION = '0.8.0';
export const entities = [
    'merchant',
    'employee',
    'anonymous_visitor',
    'capital_customer',
    'developer',
    'person',
    'unit',
    'weebly_user',
    'square_employee',
    'buyer',
];
export const falseyValues = [
    '',
    null,
    undefined,
];
export const cookiePrefixMap = {
    aud: ['audience'],
    c: ['campaignChannel'],
    cmtp: ['campaigntype'],
    cn: ['campaignname'],
    crcopy: ['creativecopy'],
    crcta: ['creativecta'],
    crim: ['creativeimage'],
    crtype: ['creativetype'],
    d: ['detailChannel', 'channel'],
    dt: ['deviceChannel', 'devicetype'],
    exp: ['experiment'],
    f: ['forecastChannel'],
    l: ['locationChannel', 'locationcountry'],
    lang: ['language'],
    meta1: ['meta1'],
    meta2: ['meta2'],
    o: ['offerChannel', 'offer'],
    p: ['partnerChannel', 'partner'],
    pr: ['productChannel', 'initiative'],
    route: ['destinationurl'],
    sq: ['marinTag'],
    subch: ['subchannel'],
    subcmtp: ['subcampaigntype'],
    subp: ['subpartner'],
    tar: ['targetingtype'],
    tarpr: ['targetproduct'],
    u: ['urlChannel'],
};
export const gclidKeySet = new Set([
    'gclid',
    'pub',
    'kw',
    'kwid',
    'matchtype',
    'device',
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NkcC9jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7OztHQUdHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUFHLGVBQWUsQ0FBQztBQUM1QyxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsT0FBTyxDQUFDO0FBRXZDLE1BQU0sQ0FBQyxNQUFNLFFBQVEsR0FBNEI7SUFDL0MsVUFBVTtJQUNWLFVBQVU7SUFDVixtQkFBbUI7SUFDbkIsa0JBQWtCO0lBQ2xCLFdBQVc7SUFDWCxRQUFRO0lBQ1IsTUFBTTtJQUNOLGFBQWE7SUFDYixpQkFBaUI7SUFDakIsT0FBTztDQUNDLENBQUM7QUFFWCxNQUFNLENBQUMsTUFBTSxZQUFZLEdBQTZCO0lBQ3BELEVBQUU7SUFDRixJQUFJO0lBQ0osU0FBUztDQUNELENBQUM7QUFFWCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQXFDO0lBQy9ELEdBQUcsRUFBRSxDQUFDLFVBQVUsQ0FBQztJQUNqQixDQUFDLEVBQUUsQ0FBQyxpQkFBaUIsQ0FBQztJQUN0QixJQUFJLEVBQUUsQ0FBQyxjQUFjLENBQUM7SUFDdEIsRUFBRSxFQUFFLENBQUMsY0FBYyxDQUFDO0lBQ3BCLE1BQU0sRUFBRSxDQUFDLGNBQWMsQ0FBQztJQUN4QixLQUFLLEVBQUUsQ0FBQyxhQUFhLENBQUM7SUFDdEIsSUFBSSxFQUFFLENBQUMsZUFBZSxDQUFDO0lBQ3ZCLE1BQU0sRUFBRSxDQUFDLGNBQWMsQ0FBQztJQUN4QixDQUFDLEVBQUUsQ0FBQyxlQUFlLEVBQUUsU0FBUyxDQUFDO0lBQy9CLEVBQUUsRUFBRSxDQUFDLGVBQWUsRUFBRSxZQUFZLENBQUM7SUFDbkMsR0FBRyxFQUFFLENBQUMsWUFBWSxDQUFDO0lBQ25CLENBQUMsRUFBRSxDQUFDLGlCQUFpQixDQUFDO0lBQ3RCLENBQUMsRUFBRSxDQUFDLGlCQUFpQixFQUFFLGlCQUFpQixDQUFDO0lBQ3pDLElBQUksRUFBRSxDQUFDLFVBQVUsQ0FBQztJQUNsQixLQUFLLEVBQUUsQ0FBQyxPQUFPLENBQUM7SUFDaEIsS0FBSyxFQUFFLENBQUMsT0FBTyxDQUFDO0lBQ2hCLENBQUMsRUFBRSxDQUFDLGNBQWMsRUFBRSxPQUFPLENBQUM7SUFDNUIsQ0FBQyxFQUFFLENBQUMsZ0JBQWdCLEVBQUUsU0FBUyxDQUFDO0lBQ2hDLEVBQUUsRUFBRSxDQUFDLGdCQUFnQixFQUFFLFlBQVksQ0FBQztJQUNwQyxLQUFLLEVBQUUsQ0FBQyxnQkFBZ0IsQ0FBQztJQUN6QixFQUFFLEVBQUUsQ0FBQyxVQUFVLENBQUM7SUFDaEIsS0FBSyxFQUFFLENBQUMsWUFBWSxDQUFDO0lBQ3JCLE9BQU8sRUFBRSxDQUFDLGlCQUFpQixDQUFDO0lBQzVCLElBQUksRUFBRSxDQUFDLFlBQVksQ0FBQztJQUNwQixHQUFHLEVBQUUsQ0FBQyxlQUFlLENBQUM7SUFDdEIsS0FBSyxFQUFFLENBQUMsZUFBZSxDQUFDO0lBQ3hCLENBQUMsRUFBRSxDQUFDLFlBQVksQ0FBQztDQUNsQixDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUFHLElBQUksR0FBRyxDQUFDO0lBQ2pDLE9BQU87SUFDUCxLQUFLO0lBQ0wsSUFBSTtJQUNKLE1BQU07SUFDTixXQUFXO0lBQ1gsUUFBUTtDQUNULENBQUMsQ0FBQyJ9